import {
  Col,
  InputField,
  Label,
  OutlineButton,
  ReactSelectBox,
  Row,
  SwitchToggle,
} from "../../../../CommonComponents";
import "./VendorDetail.scss";
import { MaskedTextField } from "@fluentui/react";
import CancelConfirmationPopup from "../CancelConfirmationpopup";
import { CONSTANTS } from "client/utils/constants";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";

interface Iprops {
  errors?: any;
  handleChange: any;
  handleClickCancel?: any;
  Popupcontent?: any;
  hideDialog?: any;
  popupOutlinebtnOnclick?: any;
  popupPrimarybtnOnclick?: any;
  purchaseOrderStepperData: any;
  updateValue: Function;
  savePurchaseOrder: Function;
  isCompleted?: boolean;
  vendorDropdownList?: any;
  onChangeVendorName?: any;
  vendorSearchText?: any;
  dealerSelectOnBlur?: any;
  vendor?: any;
  filterOptionVendor?: any;
  vendorSameAsDealeToggleClick?: any;
  showDealerSection?: any;
  vendorOptionDropdownList?: any;
  onChangeSameAsVendorName?: any;
  sameVendor?: any;
  filterOptionsameVendor?: any;
  sameDealerSelectOnBlur?: any;
  sameVendorSearchText?: any;
  isBulkOrder: boolean;
}

const VendorDetail: React.FunctionComponent<Iprops> = ({
  errors,
  handleChange,
  popupPrimarybtnOnclick,
  Popupcontent,
  hideDialog,
  popupOutlinebtnOnclick,
  handleClickCancel,
  purchaseOrderStepperData,
  savePurchaseOrder,
  isCompleted,
  vendorDropdownList,
  onChangeVendorName,
  vendorSearchText,
  dealerSelectOnBlur,
  vendor,
  filterOptionVendor,
  vendorSameAsDealeToggleClick,
  onChangeSameAsVendorName,
  sameVendor,
  filterOptionsameVendor,
  sameDealerSelectOnBlur,
  sameVendorSearchText,
  isBulkOrder
}) => (
  <>
    <p className="blueLabel mb-0 width-percent">
      {isBulkOrder ? "Vendor" : "Dealer"} Details
    </p>
    <Row className="border px-0 mx-0 stepper-vendor-details">
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_10">{isBulkOrder ? "Vendor" : "Dealer"} #</Label>
        <ReactSelectBox
          options={vendorDropdownList}
          onChange={(item: any) =>
            onChangeVendorName(
              item,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          value={vendor || ""}
          name="vendorABNumber"
          isSearchable={true}
          inputValue={vendorSearchText}
          onInputChange={(value: any, action: any) =>
            filterOptionVendor(value, action)
          }
          className={errors?.vendorABNumber ? "controlValidation me-2" : "me-2"}
          onBlur={dealerSelectOnBlur}
          isDisabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_vendorABNumber_SearchSelectBox" />
        {errors?.vendorABNumber && (
          <span className="validMessage">
            {typeof errors?.vendorABNumber === "string"
              ? errors?.vendorABNumber
              : `${isBulkOrder ? "Vendor" : "Dealer"} Number is required`}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_2_2">{isBulkOrder ? "Vendor" : "Dealer"} Name</Label>
        <InputField
          value={purchaseOrderStepperData?.poDealerDetails?.dealerName}
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          name="dealerName"
          placeholder="Automotive Rentals Inc"
          className={errors?.dealerName ? "controlValidation" : ""}
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerName_Input" />
        {errors?.dealerName && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerName?.length > 50
              ? `Please enter ${
                  isBulkOrder ? "Vendor" : "Dealer"
                } Name less then 50 characters`
              : `${isBulkOrder ? "Vendor" : "Dealer"} Name is required`}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_3_2">Email Address</Label>
        <InputField
          value={
            purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail || ""
          }
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          name="dealerContactEmail"
          placeholder="example@mail.com"
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
          className={errors?.dealerContactEmail ? "controlValidation" : ""}
         data-attribute="VendorDetail_dealerContactEmail_Input" />
        {errors?.dealerContactEmail && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail
              ?.length > 100
              ? "Please enter Email Address less than 100 characters"
              : "Please enter valid Email Address"}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_4_2">Address Line 1</Label>
        <InputField
          value={purchaseOrderStepperData?.poDealerDetails?.dealerAdd1}
          name="dealerAdd1"
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          className={errors?.dealerAdd1 ? "controlValidation" : ""}
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerAdd1_Input" />
        {errors?.dealerAdd1 && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerAdd1?.length > 50
              ? "Please enter Address Line 1 less then 50 characters"
              : "Address line 1 is required"}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label data-attribute="VendorDetail_Default_Label_5_2">Address Line 2</Label>
        <InputField
          name="dealerAdd2"
          value={purchaseOrderStepperData?.poDealerDetails?.dealerAdd2}
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerAdd2_Input" />
        {errors?.dealerAdd2 && (
          <span className="validMessage">
            "Please enter Address Line 2 less then 50 characters" :
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label data-attribute="VendorDetail_Default_Label_6_2">Address Line 3</Label>
        <InputField
          name="dealerAdd3"
          value={purchaseOrderStepperData?.poDealerDetails?.dealerAdd3}
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerAdd3_Input" />
        {errors?.dealerAdd3 && (
          <span className="validMessage">
            "Please enter Address Line 3 less then 50 characters" :
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_7_2">State/Province/Region</Label>
        <InputField
          name="dealerState"
          value={purchaseOrderStepperData?.poDealerDetails?.dealerState}
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          className={errors?.dealerState ? "controlValidation" : ""}
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerState_Input" />
        {errors?.dealerState && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerState?.length > 2
              ? "Please enter State in 2 characters"
              : "State is required"}{" "}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_8_2">City</Label>
        <InputField
          name="dealerCity"
          value={purchaseOrderStepperData?.poDealerDetails?.dealerCity}
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          className={errors?.dealerCity ? "controlValidation" : ""}
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerCity_Input" />
        {errors?.dealerCity && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerCity?.length > 50
              ? "Please enter City less then 50 characters"
              : "City is required"}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_9_2">ZIP</Label>
        <InputField
          name="dealerZip"
          value={purchaseOrderStepperData?.poDealerDetails?.dealerZip}
          onChange={(e: any) =>
            handleChange(
              e,
              undefined,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          className={errors?.dealerZip ? "controlValidation" : ""}
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
         data-attribute="VendorDetail_dealerZip_Input" />
        {errors?.dealerZip && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerZip?.length > 12
              ? "Please enter Zip less then 12 characters"
              : "ZIP is required"}
          </span>
        )}
      </Col>
      <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
        <Label required data-attribute="VendorDetail_Default_Label_10_2">Phone</Label>
        <MaskedTextField
          name="dealerPhone"
          value={purchaseOrderStepperData?.poDealerDetails?.dealerPhone || ""}
          placeholder="123-456-7890"
          mask="999-999-9999"
          onChange={(e: any, value: any) =>
            handleChange(
              e,
              value,
              purchaseOrderStepperData?.fleetRequestDetailId
            )
          }
          className={
            errors?.dealerPhone ? "controlValidation form-input" : "form-input"
          }
          disabled={
            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
            purchaseOrderStepperData?.poNumber ||
            purchaseOrderStepperData?.itemStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            !isAuthorized(
              FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
            )
          }
        />
        {errors?.dealerPhone && (
          <span className="validMessage">
            {purchaseOrderStepperData?.poDealerDetails?.dealerPhone?.length >
              0 &&
            purchaseOrderStepperData?.poDealerDetails?.dealerPhone?.length < 12
              ? "Please enter valid phone number"
              : "Phone is required"}
          </span>
        )}
      </Col>
      {!isBulkOrder && (
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="VendorDetail_Default_Label_11">Vendor Same as Dealer</Label>
          <SwitchToggle
            onChange={(event?: any, itemVal?: any, item?: any) =>
              vendorSameAsDealeToggleClick(
                event,
                itemVal,
                item,
                purchaseOrderStepperData?.fleetRequestDetailId
              )
            }
            checked={purchaseOrderStepperData?.isVendorSameAsDealer}
            disabled={
              purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
              purchaseOrderStepperData?.poNumber ||
              purchaseOrderStepperData?.itemStatus ==
                CONSTANTS.ORDER_STATUS.CANCELLED ||
              !isAuthorized(
                FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
              )
            }
           data-attribute="VendorDetail_Default_SwitchToggle" />
        </Col>
      )}
    </Row>
    {!purchaseOrderStepperData?.isVendorSameAsDealer && !isBulkOrder ? (
      <>
        <p className="blueLabel width-percent">Vendor Details</p>
        <Row className="border px-0 mx-0 stepper-vendor-details mt-0">
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label required data-attribute="VendorDetail_Default_Label_12">Vendor #</Label>
            <ReactSelectBox
              options={vendorDropdownList}
              onChange={(item: any) =>
                onChangeSameAsVendorName(
                  item,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              value={sameVendor || ""}
              name="vendorAbNumber"
              isSearchable={true}
              inputValue={sameVendorSearchText}
              onInputChange={(value: any, action: any) =>
                filterOptionsameVendor(value, action)
              }
              className={
                errors?.vendorAbNumber ? "controlValidation me-2" : "me-2"
              }
              onBlur={sameDealerSelectOnBlur}
              isDisabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorAbNumber_SearchSelectBox_2" />
            {errors?.vendorABNumber && (
              <span className="validMessage">Vendor Number is required</span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label required data-attribute="VendorDetail_Default_Label_13">Vendor Name</Label>
            <InputField
              value={purchaseOrderStepperData?.poVendorDetails?.vendorName}
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              name="vendorName"
              className={errors?.vendorName ? "controlValidation" : ""}
              disabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorName_Input_2" />
            {errors?.vendorName && (
              <span className="validMessage">
                {purchaseOrderStepperData?.poVendorDetails?.vendorName?.length >
                50
                  ? "Please enter Vendor Name less then 50 characters"
                  : "Vendor Name is required"}
              </span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label data-attribute="VendorDetail_Default_Label_14">Email Address</Label>
            <InputField
              value={
                purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail ||
                ""
              }
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              name="vendorContactEmail"
              placeholder="example@mail.com"
              className={errors?.vendorContactEmail ? "controlValidation" : ""}
              disabled={    
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorContactEmail_Input_2" />
            {errors?.vendorContactEmail && (
              <span className="validMessage">
                {purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail
                  ?.length > 100
                  ? "Please enter Email Address less than 100 characters"
                  : "Please enter valid Email Address"}
              </span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label required data-attribute="VendorDetail_Default_Label_15">Address Line 1</Label>
            <InputField
              value={purchaseOrderStepperData?.poVendorDetails?.vendorAdd1}
              name="vendorAdd1"
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              className={errors?.vendorAdd1 ? "controlValidation" : ""}
              disabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorAdd1_Input_2" />
            {errors?.vendorAdd1 && (
              <span className="validMessage">
                {purchaseOrderStepperData?.poVendorDetails?.vendorAdd1?.length >
                50
                  ? "Please enter Address Line 1 less then 50 characters"
                  : "Address Line 1 is required"}
              </span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label data-attribute="VendorDetail_Default_Label_16">Address Line 2</Label>
            <InputField
              name="vendorAdd2"
              value={purchaseOrderStepperData?.poVendorDetails?.vendorAdd2}
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              disabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorAdd2_Input_2" />
            {errors?.vendorAdd2 && (
              <span className="validMessage">
                Please enter Address Line 2 less then 50 characters
              </span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label required data-attribute="VendorDetail_Default_Label_17">State/Province/Region</Label>
            <InputField
              name="vendorState"
              value={purchaseOrderStepperData?.poVendorDetails?.vendorState}
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              className={errors?.vendorState ? "controlValidation" : ""}
              disabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorState_Input_2" />
            {errors?.vendorState && (
              <span className="validMessage">
                {purchaseOrderStepperData?.poVendorDetails?.vendorState
                  ?.length > 2
                  ? "Please enter State in 2 characters"
                  : "State/Province/Region is required"}
              </span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label required data-attribute="VendorDetail_Default_Label_18">City</Label>
            <InputField
              name="vendorCity"
              value={purchaseOrderStepperData?.poVendorDetails?.vendorCity}
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              className={errors?.vendorCity ? "controlValidation" : ""}
              disabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorCity_Input_2" />
            {errors?.vendorCity && (
              <span className="validMessage">
                {purchaseOrderStepperData?.poVendorDetails?.vendorCity?.length >
                50
                  ? "Please enter City less than 50 characters"
                  : "City is required"}
              </span>
            )}
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label required data-attribute="VendorDetail_Default_Label_19">ZIP</Label>
            <InputField
              name="vendorZip"
              value={purchaseOrderStepperData?.poVendorDetails?.vendorZip}
              onChange={(e: any) =>
                handleChange(
                  e,
                  undefined,
                  purchaseOrderStepperData?.fleetRequestDetailId
                )
              }
              className={errors?.vendorZip ? "controlValidation" : ""}
              disabled={
                purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                purchaseOrderStepperData?.poNumber ||
                purchaseOrderStepperData?.itemStatus ==
                  CONSTANTS.ORDER_STATUS.CANCELLED ||
                !isAuthorized(
                  FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
                )
              }
             data-attribute="VendorDetail_vendorZip_Input_2" />
            {errors?.vendorZip && (
              <span className="validMessage">
                {purchaseOrderStepperData?.poVendorDetails?.vendorZip?.length >
                12
                  ? "Please enter Zip less then 12 characters"
                  : "ZIP is required"}
              </span>
            )}
          </Col>
        </Row>{" "}
      </>
    ) : (
      ""
    )}

    <div className="vendor-detail-btn vendorDetailBtns">
      <OutlineButton
        text="Save"
        className="pull-right save-vendor"
        onClick={savePurchaseOrder}
        disabled={
          purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
          purchaseOrderStepperData.loading ||
          isCompleted ||
          purchaseOrderStepperData?.poNumber ||
          purchaseOrderStepperData?.itemStatus ==
            CONSTANTS.ORDER_STATUS.CANCELLED ||
          !isAuthorized(
            FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS
          )
        }
       data-attribute="VendorDetail_Default_Button"></OutlineButton>
      <OutlineButton
        text="Cancel"
        className="cancel-vendor me-2"
        onClick={handleClickCancel}
       data-attribute="VendorDetail_Default_Button_2" />
      <CancelConfirmationPopup
        hideDialog={hideDialog}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={popupOutlinebtnOnclick}
        popupPrimarybtnOnclick={() => popupPrimarybtnOnclick("Home")}
      />
    </div>
  </>
);

export default VendorDetail;
